package com.neurobs.js.ccab

import com.neurobs.ccab.{ObjectResult, TestRun}
import com.neurobs.ccab.casr.{ReviewedTestTranscriptCreateData, ReviewedTestTranscriptUpdateData, ReviewerView, TranscriptMetrics}
import com.neurobs.ccab.db.{FileTranscriptData, FileTranscriptRequestData, FileTranscriptResponseData, ReviewedTestTranscriptData, SpeechAudioFileData, TestTranscriptData}
import com.neurobs.util.JsonPrinter.jsonPrint
import com.neurobs.js.ccab.CCABServer.makeUrlSuffix
import com.neurobs.js.http
import io.circe.generic.auto._

object CASRServer {

  def getSpeechAudioFilesWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[SpeechAudioFileData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(("timeframe_seconds", Some(timeframeSeconds))))
    http.getServerObjectAsync[ObjectResult[Seq[SpeechAudioFileData]]](
      url = s"/api/v1/speech_audio_files/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getTestTranscriptsWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[TestTranscriptData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(
      ("timeframe_seconds", Some(timeframeSeconds))
    ))
    http.getServerObjectAsync[ObjectResult[Seq[TestTranscriptData]]](
      url = s"/api/v1/test_transcripts/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getTestRunReviewers(accountId: Long, testRunId: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[ReviewerView]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(
      ("account_id", Some(accountId)),
      ("test_run_id", Some(testRunId))
    ))
    http.getServerObjectAsync[ObjectResult[Seq[ReviewerView]]](
      url = s"/api/v1/reviewed_test_transcripts/reviewers/$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def updateReviewedTestTranscript(data: ReviewedTestTranscriptUpdateData)(onComplete: http.ServerObjectResponse[ObjectResult[ReviewedTestTranscriptData]] => Unit) = {
    http.getServerObjectAsync[ObjectResult[ReviewedTestTranscriptData]](
      url = s"/api/v1/reviewed_test_transcripts/",
      data = jsonPrint(data),
      t = http.HTTPRequestType.Put
    )(onComplete)
  }

  def createReviewedTestTranscript(data: ReviewedTestTranscriptCreateData)(onComplete: http.ServerObjectResponse[ObjectResult[ReviewedTestTranscriptData]] => Unit) = {

    http.getServerObjectAsync[ObjectResult[ReviewedTestTranscriptData]](
      url = s"/api/v1/reviewed_test_transcripts/",
      data = jsonPrint(data),
      t = http.HTTPRequestType.Post
    )(onComplete)
  }

  def getReviewedTestTranscriptsWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[ReviewedTestTranscriptData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(
      ("timeframe_seconds", Some(timeframeSeconds))
    ))
    http.getServerObjectAsync[ObjectResult[Seq[ReviewedTestTranscriptData]]](
      url = s"/api/v1/reviewed_test_transcripts/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getTranscriptMetricsForStudy(studyId: Long)(onComplete: http.ServerObjectResponse[ObjectResult[TranscriptMetrics]] => Unit) = {
    http.getServerObjectAsync[ObjectResult[TranscriptMetrics]](
      url = s"/api/v1/transcript_metrics/study/$studyId",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def runS3Sync(onComplete: Option[http.ServerError] => Unit) = {
    http.serverCallAsyncNoResponse(
      url = "/api/v1/s3sync",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getFileTranscriptsWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[FileTranscriptData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(("timeframe_seconds", Some(timeframeSeconds))))
    http.getServerObjectAsync[ObjectResult[Seq[FileTranscriptData]]](
      url = s"/api/v1/file_transcripts/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getFileTranscriptRequestsWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[FileTranscriptRequestData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(("timeframe_seconds", Some(timeframeSeconds))))
    http.getServerObjectAsync[ObjectResult[Seq[FileTranscriptRequestData]]](
      url = s"/api/v1/file_transcripts/requests/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

  def getFileTranscriptResponsesWithinTimeframe(timeframeSeconds: Long)(onComplete: http.ServerObjectResponse[ObjectResult[Seq[FileTranscriptResponseData]]] => Unit) = {
    val suffix = makeUrlSuffix(Seq(("timeframe_seconds", Some(timeframeSeconds))))
    http.getServerObjectAsync[ObjectResult[Seq[FileTranscriptResponseData]]](
      url = s"/api/v1/file_transcripts/responses/timeframe$suffix",
      t = http.HTTPRequestType.Get
    )(onComplete)
  }

}
